define('customPlugins/atnCustomDialog/initAtnCustomDialog',['durandal/app', 'plugins/dialog', 'text!./atnCustomDialog.html', 'lodash'],
    function(app, dialog, dialogHTML, _) {
        'use strict';
        return initATNCustomDialog;

        function initATNCustomDialog() {
            dialog.MessageBox.defaultViewMarkup = dialogHTML;
            app.atnCustomDialog = function(message, title, options, selectedIndex) {
                options.selectedIndex = _.isNaN(parseInt(selectedIndex, 10)) ? 0 : selectedIndex;
                return app.showMessage(message, title, options);
            };
        }
    });
